import React, { Component } from "react";
import PageContext, { updatePageContext, getPageContext } from "../../components/Common/PageContext";
import PendingCreditRequestList from "../../components/CreditRequest/PendingCreditRequestList";
import { getCreditRequestsByStatusesAndStoreNumber } from "../../services/apiHelper";
import { LoadingDialog } from "../../components/Loading/LoadingDialog";
import { setStateAsync } from "../../util/stateHelper";
import qs from "qs";
import { ModalWithActionButton } from "../../components/Modal/ModalWithActionButton";

interface PendingCreditRequestsProps {
	classes?: any;
	location?: any;
	history?: any;
}

interface PendingCreditRequestsState {
	creditRequests: any[];
	status: string;
	error: { show: boolean; message: string };
	isShowLoadingDialog: boolean;
}

class PendingCreditRequests extends Component<PendingCreditRequestsProps, PendingCreditRequestsState> {
	setStateAsync: (state: Partial<PendingCreditRequestsState>) => Promise<void>;
	updatePageContext: (context: any, callback?: () => void) => void;
	getPageContext: () => any;

	constructor(props: PendingCreditRequestsProps) {
		super(props);
		this.state = {
			creditRequests: [],
			status: "",
			error: { show: false, message: "" },
			isShowLoadingDialog: false,
		};
		this.setStateAsync = setStateAsync.bind(this);
		this.updatePageContext = updatePageContext.bind(this);
		this.getPageContext = getPageContext.bind(this);
	}

	static contextType = PageContext;

	async componentDidMount() {
		await this.process();
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.location !== prevProps.location) {
			await this.process();
		}
	}

	process = async () => {
		try {
			await this.setStateAsync({ isShowLoadingDialog: true });

			const queryStringObject = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
			const { status } = queryStringObject;
			const { userLocation } = this.getPageContext();
			const creditRequests = await getCreditRequestsByStatusesAndStoreNumber([status], userLocation) as any[];

			await this.setStateAsync({
				creditRequests,
				isShowLoadingDialog: false,
				status,
			});
			this.sortCreditRequestsByDateAsync();
		} catch (error: any) {
			console.log(error);
			this.setStateAsync({
				creditRequests: [],
				error: { show: true, message: error?.response },
				isShowLoadingDialog: false,
			});
		}
	};

	sortCreditRequestsByDateAsync = async () => {
		let { creditRequests, status } = this.state;
		creditRequests = creditRequests?.sort((a, b) => {
			const aDateCreated = a.lineItems.find((li) => li.status === status).dateCreated;
			const bDateCreated = b.lineItems.find((li) => li.status === status).dateCreated;
			return Date.parse(aDateCreated) - Date.parse(bDateCreated);
		});
		await this.setStateAsync({ creditRequests });
	};

	handleCloseAlertAsync = async (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		await this.setStateAsync({ error: { show: false, message: "" } });
	};

	onSelectCreditRequestAsync = async (friendlyId) => {
		const { creditRequests } = this.state;
		const matchingCreditRequest = creditRequests.find((cr) => cr.friendlyId === friendlyId);

		this.props.history.push(`/creditrequest/detail?id=${matchingCreditRequest.id}`);
	};

	renderPendingCreditRequestList = () => {
		const { creditRequests, status } = this.state;
		if (creditRequests && creditRequests.length > 0) {
			return (
				<PendingCreditRequestList
					creditRequests={creditRequests}
					onView={this.onSelectCreditRequestAsync}
					status={status}
				/>
			);
		}
		return null;
	};

	render() {
		return (
			<React.Fragment>
				{this.renderPendingCreditRequestList()}
				<LoadingDialog message={"Retrieving Credit Requests..."} isOpen={this.state.isShowLoadingDialog} />
				<ModalWithActionButton
					title="Error"
					alertType="error"
					primaryButtonName="Ok"
					onPrimaryButtonClick={() => this.handleCloseAlertAsync(undefined, undefined)}
					isOpen={this.state.error.show}
					message={this.state.error.message}
				/>
			</React.Fragment>
		);
	}
}
export default PendingCreditRequests;
